import { createActionName } from "redux/utility"

export const reducerName = "invites"

export const INVITE = createActionName(reducerName, "INVITE")

export const INVITE_RESEND = `${INVITE}_RESEND`
